export const formatCurrency = (amount, language = 'en') => {
    // Convert to number and handle invalid values - be more defensive
    let numericAmount;
    try {
        // Handle strings that might look like numbers
        if (typeof amount === 'string') {
            numericAmount = parseFloat(amount.replace(/[^\d.-]/g, ''));
        } else {
            numericAmount = Number(amount);
        }
        
        // If still NaN, return default value
        if (isNaN(numericAmount)) {
        
            return language === 'ar' ? '0.00 ر.س' : 'SAR 0.00';
        }
    } catch (e) {
        console.error('[formatCurrency] Error formatting amount:', e);
        return language === 'ar' ? '0.00 ر.س' : 'SAR 0.00';
    }
    
    try {
        return new Intl.NumberFormat(language === 'ar' ? 'ar-SA' : 'en-US', {
            style: 'currency',
            currency: 'SAR',
            currencyDisplay: 'code',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(numericAmount).replace('SAR', language === 'ar' ? 'ر.س' : 'SAR');
    } catch (e) {
        console.error('[formatCurrency] Error in formatter:', e);
        return language === 'ar' ? `${numericAmount.toFixed(2)} ر.س` : `SAR ${numericAmount.toFixed(2)}`;
    }
};

export const formatNumber = (number, language = 'en') => {
    // Convert to number and handle invalid values
    const numericValue = Number(number);
    if (isNaN(numericValue)) {
        return '0';
    }
    
    return new Intl.NumberFormat(language === 'ar' ? 'ar-SA' : 'en-US').format(numericValue);
};

export const formatDate = (dateString, language = 'en') => {
    if (!dateString) return '';
    
    return new Date(dateString).toLocaleString(language === 'ar' ? 'ar-SA' : 'en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        calendar: 'gregory'
    });
};
